<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.given_name + ' ' + recordData.family_name : ''}}</h1>
      </div>
    </div>

    <template
      v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs">

        <md-tab id="tab-user" md-label="User" :to="recordPath" exact>
          <CustomUserForm :atShowAuditLog="onShowAuditLog" :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :headerColor="headerColor"></CustomUserForm>
          <md-dialog :md-active.sync="auditLogDialog">
            <md-dialog-title>Audit Log</md-dialog-title>
            <md-dialog-content>
              <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"
              ></AuditLogDialog>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="auditLogDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

        <md-tab id="tab-team" md-label="Team" :to="recordPath + '/teams'">
          <ElasticList 
            ref="teamsListRef"
            v-if="$route && $route.meta.tab === 'teams'" 
            :list.sync="teamsList" 
            :filter="teamUserUserId">
          </ElasticList>

          <md-dialog :md-active.sync="teamsList.showRelatedDialog">
            <md-dialog-title>{{relateTeamList.pageTitle}}</md-dialog-title>
            <md-dialog-content>

              <ElasticList
                v-if="recordData"

                :list.sync="relateTeamList"
                :exclude="relateUserTeamFilter"
                :relateRecordInput="{teamUserTeamId: null,  teamUserUserId: $route.params.id}"
                relateRecordInputField="teamUserTeamId"
              ></ElasticList>

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="teamsList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <CustomUserForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :headerColor="headerColor"></CustomUserForm>
    </div>


  </div>
</template>

<script>
  import _ from "lodash";
  import Record from '@/mixins/Record';
  import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
  import moment from 'moment';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";

  export default {
    name: "product",
    mixins: [Record],
    components: {
      AuditLogDialog
    },
    computed: {
      auditLogFilter() {
        return [
          { match_phrase: { modelName: 'User' } },
          { match_phrase: { modelId: this.$route.params.id } },
        ];
      },
      teamUserUserId: function() { return { match_phrase: { 'teamUserUserId': this.$route.params.id } }; },
      personCompanyPersonId: function () { return {"personCompanyPersonId": {"eq": this.$route.params.id }}; },
      relateCompanyPersonFilter: function () {
        let result = null;
        if (this.recordData && this.recordData.companys && this.recordData.companys.items) {
          let companys = this.recordData.companys.items;
          let filters = [];

          companys.forEach(item => {
            filters.push({"id": {"ne": item.id}});
          });
          if (filters.length) {
            result = {"and": filters};
          }
        }

        return result;
      },
      relateUserTeamFilter: function() {
        let result = null;
        if (this.recordData && this.recordData.teams && this.recordData.teams.items) {
          let items = this.recordData.teams.items;
          let filters = [];
          items.forEach(item => {
            filters.push({"match": {"cognito_groupid": item.cognito_groupid}});
          });
          if (filters.length) {
            result = {"must_not": filters};
          }
        } 
        return result;
      },
    },
    data() {
      return {
        auditLogDialog: false,
        auditLogList: {
          hideItemActions: true,
          hideListHeader: true,
          skipCardLayout: true,
          hideNewRecordButton: true,
          searchRecordsInput: false,
          pageTitle: "Change History",
          listQueryId: "searchChanges",
          columns: {
            createdAt: { label: "Created", sortable: true },
            user: { label: "Owner", sortable: false },
            change: { label: "Change", sortable: false },
          },
          currentSort: "createdAt",
          currentSortOrder: "asc",
          pagination: {
            perPage: 10,
            currentPage: 1,
            total: 0,
            perPageOptions: [5, 10, 20, 25, 50],
            perPageMaxLimit: 999
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          assigneeList: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchChanges && data.searchChanges.items.length) {
              let items = data.searchChanges.items;
              items.forEach((item) => {
                /** Format user and change for display */
                item.user = item.user ? item.user.given_name + ' ' + item.user.family_name : item.owner;
                item.createdAt = moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a')                
                if (item.change)  {
                  let change = '';
                  _.mapKeys(JSON.parse(item.change), function(value, key) {
                    if(/(Mon|Tue|Wed|Thu|Fri|Sat|Sun)\,\s+(\d{2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{4})\s+(\d{2}\:\d{2}\:\d{2})\s+(GMT)/ig.test(value)) {
                      change = change + key + ' : ' + moment(value).format("MMM DD, YYYY") + ', ';
                    } else 
                      change = change + key + ' : ' + value + ', ';
                  });
                  item.change = change;
                } 
                result.push(item);
              })
            }
            return this.orderedAuditLog(result)
          },
        },
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'userUpdatedById',
          responseFieldName: 'getUser',
          actions: {
            save: 'createUser',
            view: 'getUser',
            edit: 'getUser',
            new: 'getUser',
            update: 'updateUser',
            delete: 'deleteUser',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":12,"i":"0"}},
            role: {label: 'Role Information', icon: 'work', editModeOnly: true, layout: {"x":0,"y":12,"w":12,"h":12,"i":"1"}},
          },
          listPath: "/users",
          headerIcon: 'emoji_people',
          objectName: 'User',
          objectNamePlural: 'Users',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']

          fields: {
            id: { label: "ID", type: "id", slot: 'basic', value: "" },
            cogEmailVerified: { label: "Email Verified", type: "checkbox", slot: 'basic', preventEdit: true },
            cogUserStatus: { label: "Cognito Status", type: "select", slot: 'basic', preventEdit: true,  options: [
              {name: 'UNCONFIRMED', id: 'UNCONFIRMED'},
              {name: 'CONFIRMED', id: 'CONFIRMED'},
              {name: 'ARCHIVED', id: 'ARCHIVED'},
              {name: 'COMPROMISED', id: 'COMPROMISED'},
              {name: 'UNKNOWN', id: 'UNKNOWN'},
              {name: 'RESET_REQUIRED', id: 'RESET_REQUIRED'},
              {name: 'FORCE_CHANGE_PASSWORD', id: 'FORCE_CHANGE_PASSWORD'},
            ] },
            cogUsername: { label: "Cognito ID", type: "text", slot: 'basic', preventEdit: true },
            email: { label: "Email", type: "text", slot: 'basic', preventEdit: false },
            given_name: { label: "First Name", type: "text", slot: 'basic' },
            family_name: { label: "Last Name", type: "text", slot: 'basic' },
            source: { label: "Source", type: "text", slot: 'basic', preventEdit: true },
            createdAt: { label: "Created", type: "text", slot: 'basic', preventEdit: true },
            updatedAt: { label: "Last Modified", type: "text", slot: 'basic', preventEdit: true },
            IPCorp: { label: "IPCorp", type: "checkbox", slot: 'role', preventEdit: false },
            internal: { label: "Internal", type: "checkbox", slot: 'role', preventEdit: false },
            TaskSaveAsTemplate: { label: "TaskSaveAsTemplate", type: "checkbox", slot: 'role', preventEdit: false },
            CaseSaveAsTemplate: { label: "CaseSaveAsTemplate", type: "checkbox", slot: 'role', preventEdit: false },
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          cogEmailVerified: "",
          cogUserStatus: "",
          cogUsername: "",
          email: "",
          given_name: "",
          family_name: "",
          source: "Admin",
          createdAt: "",
          updatedAt: "",
          IPCorp: "",
          internal: "",
          TaskSaveAsTemplate: "",
          CaseSaveAsTemplate: "",
        },
        teamsList: {
          refreshData: false,
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "users",
          pageTitle: "Teams",
          pageIcon: "style",
          listQueryId: "searchTeamUsers",
          deleteQueryId: "deleteTeamUser",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Team?",
          deleteMessageText: "",
          deleteMessageNameFields: ['given_name'],
          userGroupId: "cognito_groupid",
          columns: {
            //given_name: { label: "First Name", sortable: false },
            //family_name: { label: "Last Name", sortable: false },
            role: { label: "Role", sortable: false },
            cognito_groupid: { label: "Name", sortable: false },
            createdAt: { label: "Created", sortable: false },
          },
          searchRecordsInput: false,
          currentSort: "createdAt",
          currentSortOrder: "asc",
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0,
            //perPageMaxLimit: 999
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],

          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchTeamUsers && data.searchTeamUsers.items.length) {
              this.$c.log('formatResponse data', data.searchTeamUsers.items);
              data.searchTeamUsers.items.forEach((item) => { 
                item.team.relateRecordId = item.id;
                item.team.given_name = item.user.given_name;
                item.team.family_name = item.user.family_name;
                item.team.cognito_groupid = item.team.cognito_groupid.replace(/_/g, " ");
                item.team.role = 'Team ' + item.role;
                result.push(item.team);
              })
            }
            return result;
          },
        },
        relateTeamList: {
          hideListHeader: true,
          skipCardLayout: true,
          teamFroup:'',
          editPath: "team",
          pageTitle: "Search for Team",
          pageIcon: "style",
          listQueryId: "searchTeams",
          createMutationId: "createTeamUser",
          deleteQueryId: "deleteTeamUser",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAddRole"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true },
          },
          roleRecord: {
            Lead: "Team Lead", 
            Member: "Team Member",
            Watcher: "Team Watcher"
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'asc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchTeams';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                result.push(item);
              })
            }
            return result;
          },
        },
        companysList: {
          showRelatedDialog: false,
          editPath: "companies",
          pageTitle: "Companies",
          pageIcon: "store",
          listQueryId: "listPersonCompanys",
          deleteQueryId: "deletePersonCompany",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Person?",
          deleteMessageText: "",
          columns: {
            name: { label: "Name", sortable: true },
            phone: { label: "Phone", sortable: true },
            phoneExt: { label: "Phone Ext", sortable: true },
          },
          searchFields: ["name"],
          currentSort: "name",
          currentSortOrder: "asc",
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          formatResponse: (data) => {

            let result = [];
            if (data && data.listPersonCompanys && data.listPersonCompanys.items.length) {
              this.$c.log('formatResponse data', data.items);
              data.listPersonCompanys.items.forEach((item) => {
                item.company.relateRecordId = item.id;
                result.push(item.company);
              })
            }
            return result;
          },
        },
        relateCompanysList: {
          hideListHeader: true,
          editPath: "companies",
          pageTitle: "Search for Company",
          pageIcon: "store",
          listQueryId: "listCompanys",
          createMutationId: "createPersonCompany",
          deleteQueryId: "deletePersonCompany",
          columns: {
            name: { label: "Name", sortable: true },
            phone: { label: "Phone", sortable: true },
          },
          searchFields: ["name", "phone", "phoneExt"],
          currentSort: "name",
          currentSortOrder: "asc",
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.listCompanys && data.listCompanys.items.length) {
              result = data.listCompanys.items;
            }
            return result;
          },

        },
        subscriptions: {
          'onCreateTeamUser': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateTeamUser');
              let eventRecord = eventData.value.data.onCreateTeamUser;
              /** Filter out records that do not apply to the Portfolio we are looking at */
              if (this.recordData.id === eventRecord.user.id) {
                // refresh teams list after 1 sec
                setTimeout(() => {
                  this.$refs.teamsListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 1000);
              }
            }
          },
          'onDeleteTeamUser': { 
            result: null,
            load: true,
            function: (eventData) => { 
              this.$c.log('SUBSCRIPTION Trigger: onDeleteTeamUser');
              let eventRecord = eventData.value.data.onDeleteTeamUser;
              if (this.recordData.id === eventRecord.user.id) {
                // refresh teams list after 1 sec
                setTimeout(() => {
                  this.$refs.teamsListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 1000);
              }
            }
          },
          
        },
      }
    },
    validations() {
      return {
        form: {
          id: {value: {}},
          cogEmailVerified: {},
          cogUserStatus: {},
          cogUsername: {},
          email: {required, minLength: minLength(3)},
          given_name: {required, minLength: minLength(3)},
          family_name: {required, minLength: minLength(3)},
          source: {},
          createdAt: {},
          updatedAt: {},
          IPCorp: {},
          internal: {},
          TaskSaveAsTemplate: {},
          CaseSaveAsTemplate: {},
        },
      }
    },
    methods: {
      orderedAuditLog: function (items) {
        return _.orderBy(items, 'createdAt', 'desc');
      },
      onShowAuditLog () {
        this.auditLogDialog = true;
      }, 
    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

</style>
